import { render } from "./Orders.vue?vue&type=template&id=2d876c2a&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=2d876c2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d876c2a"

export default script